import React from "react";

export default function ErrorField({ children }) {
  return (
    <div id="error-field" className="text-red-500">
      {children}
    </div>
  );
}
